import qs from 'qs';

export const getURLSearchParams = (queryParams: Record<string, unknown>): string => {
  return qs.stringify(queryParams, { arrayFormat: 'brackets' });
};
